import { IconBrandTelegram } from '@tabler/icons-react';
import { TELEGRAM_CHANNEL_URL } from '../../config/contacts';
import './AppFooter.scss';

export default function AppFooter() {
    return (
        <footer className="app-footer">
            <a
                className="app-footer__link"
                href={TELEGRAM_CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                <IconBrandTelegram size={16} stroke={1.5} aria-hidden="true" />
                Мы в Telegram
            </a>
        </footer>
    );
}
